import { useEffect, useState } from "react";
import { Header } from "@/components/Header";
import { CategoryTabs } from "@/components/CategoryTabs";
import { VideoCard } from "@/components/VideoCard";
import { SearchOverlay } from "@/components/SearchOverlay";
import { api } from "@/lib/api";

const CATEGORIES = ["All", "Music", "News", "Breaking News", "Natok", "Drama", "Food", "Travel"];

export default function Explore() {
  const [category, setCategory] = useState("All");
  const [feed, setFeed] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchOpen, setSearchOpen] = useState(false);

  useEffect(() => {
    let active = true;
    setLoading(true);
    api
      .get("/videos", { params: { category, source: "All", limit: 24 } })
      .then(({ data }) => { if (active) setFeed(data.items || []); })
      .catch(() => { if (active) setFeed([]); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [category]);

  return (
    <>
      <Header onSearch={() => setSearchOpen(true)} />
      <div className="px-4 pt-2 pb-1">
        <h1 className="font-heading text-3xl font-bold">Explore</h1>
        <p className="text-white/55 text-sm">Browse Bangladeshi content by category</p>
      </div>
      <CategoryTabs categories={CATEGORIES} active={category} onChange={setCategory} />
      {loading ? (
        <div className="grid grid-cols-1 gap-5 px-4 mt-3">
          {[1, 2, 3].map((i) => (
            <div key={i} className="aspect-video rounded-xl bg-bg-surface animate-pulse" />
          ))}
        </div>
      ) : (
        <div className="grid grid-cols-1 gap-5 px-4 mt-3">
          {feed.map((v) => <VideoCard key={v.video_id} video={v} variant="full" />)}
        </div>
      )}
      <SearchOverlay open={searchOpen} onClose={() => setSearchOpen(false)} />
    </>
  );
}
